import { render, staticRenderFns } from "./ResumeTab.vue?vue&type=template&id=79298242&scoped=true"
import script from "./ResumeTab.vue?vue&type=script&lang=js"
export * from "./ResumeTab.vue?vue&type=script&lang=js"
import style0 from "./ResumeTab.vue?vue&type=style&index=0&id=79298242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79298242",
  null
  
)

export default component.exports